import Repository from './Repository';
import {AxiosResponse} from "axios";
import {Doctor} from "@/models/doctor.models";

const resource = '/doctor';

export default new class{
    getTeams(team: string): Promise<AxiosResponse<Doctor[]>>{
        // (`${resource}/${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}/${team}/${permission}`);
        return Repository.get<Doctor[]>(`${resource}/${team}`);
    }
}
